import { createApi } from '@reduxjs/toolkit/query/react'
import { rtkBaseQuery } from 'Src/api'

export const verifyAccountApi = createApi({
  baseQuery: rtkBaseQuery,
  reducerPath: 'verifyTranscriptEmailApi',
  endpoints: (builder) => ({
    verifyTranscriptEmail: builder.query({
      query: (token) => `/v1/verify-transcript-email/${token}`
    })
  })
})

export const { useVerifyTranscriptEmailQuery } = verifyAccountApi

export default verifyAccountApi
